import { useWorkspaceContext } from '@core/contexts/workspace-context'
import { useConversation } from '@core/hooks/useConversation'
import { ContentWithAppHeader } from '@design/components/layouts/content-with-app-header/ContentWithAppHeader'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/$workspaceId/agent')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspace } = useWorkspaceContext()
  const { enterScope } = useConversation()
  const workspaceId = workspace.id

  useEffect(() => {
    enterScope(
      { type: 'workspace', workspaceId },
      { label: workspace.name, workspaceId }
    )
  }, [workspaceId, workspace.name, enterScope])

  return (
    <ContentWithAppHeader>
      <Outlet />
    </ContentWithAppHeader>
  )
}
